module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAS9JREFUeNqsVMERgjAQDBkKgA54+Y4daAeWoA/fagWOFahvH9CBdiBWYPj6kQ60A904hx4xIDDezE5mktyym7vDE47ozXcKywwYAJF1nAMpsL1sptrO9SyiAEsMjESzOAATEN+/CInsCChLzYpWE3sgsEiNymFB6teQJcAJWDps81CU238TsgMexva4oXVV9YYP0SFg980jHRVsG6UcCVURU6Y7EJZyJOTmTHJWk2jaw6O7C7af1fXhgCrWJoak8lpYvhn8y7JvVesO8vxH35UKwqYkfBFiI3R8MaI3SypmfY5l7XLkO+5n1NQxEuMfCr+K6CPpTJ2uoahPf5JlQ8upvSHZ2KgOhdEuQs0P6ZHzlgX5WCaboqIwrdS5Zlk0mJjaO5K1Ap/ptEtBTDwFGADMam3nFNbyFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/update-someoff.png
// module id = Cf0d
// module chunks = 1